import { BeneficioApi as Api } from "./beneficio.api";
import { ComercioFacade } from "../comercio/comercio.facade";

export class BeneficioFacade {
  static countWithFilter({
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined,
    estado = undefined
  }) {
    const filterDto = {
      busqueda,
      idComercio,
      subcategoria,
      estado: estado
    };

    return Api.countWithFilter(filterDto);
  }

  static create(data) {
    return Api.create(data);
  }

  static deleteById(id) {
    return Api.deleteById(id);
  }

  static getListWithFilter({
    desde = 1,
    hasta = 20,
    busqueda = undefined,
    idComercio = undefined,
    subcategoria = undefined,
    estado = undefined
  }) {
    const filterDto = {
      busqueda,
      desde,
      hasta,
      idComercio,
      subcategoria,
      estado: estado
    };

    return Api.getListWithFilter(filterDto);
  }

  static getMinimumDiscountPercentage() {
    return ComercioFacade.getMinimumDiscountPercentage();
  }

  static getTipoDescuentoList() {
    return Api.getTipoDescuentoList();
  }

  static getUnidadesDescuentoList() {
    return Api.getUnidadesDescuentoList();
  }

  static update(data) {
    return Api.update(data);
  }
}
